import React, { useEffect } from 'react';
import { ComponentProps } from '@app/participant-fields';
import { Criterion, ListValueType } from 'queries';
import { CriterionText } from './CriterionText';
import { CriterionGeolocation } from './CriterionGeolocation';

export const DeprecatedGeolocationCriterionGate = (
  props: ComponentProps<Criterion>,
) => {
  const criterion = props.value;
  const allowList = criterion?.allowList;
  const first = allowList?.[0];

  useEffect(() => {
    if (!allowList?.length && criterion.listValueType === ListValueType.TEXT) {
      props.onChange({
        ...criterion,
        listValueType: ListValueType.LOCATION,
        allowList: [],
      });
    }
  }, [criterion, allowList]);

  if (first && typeof first === 'string') {
    return <CriterionText {...props} />;
  }
  return <CriterionGeolocation {...props} />;
};
